import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderEcomerceComponent } from './header-ecomerce/header-ecomerce.component';
import { RouterModule } from '@angular/router';
import { FooterEcomerceComponent } from './footer-ecomerce/footer-ecomerce.component';
import { NavbarEcomerceComponent } from './navbar-ecomerce/navbar-ecomerce.component';
import { FooterSucursalEcomerceComponent } from './footer-sucursal-ecomerce/footer-sucursal-ecomerce.component';
import { SharedModule } from "../../shared/shared.module";
import { FormsModule } from '@angular/forms';
import { SidebarEcomerceComponent } from './sidebar-ecomerce/sidebar-ecomerce.component';


@NgModule({
    declarations: [
        HeaderEcomerceComponent,
        FooterEcomerceComponent,
        NavbarEcomerceComponent,
        FooterSucursalEcomerceComponent,
        SidebarEcomerceComponent,

    ],
    exports: [
        HeaderEcomerceComponent,
        FooterEcomerceComponent,
        FooterSucursalEcomerceComponent,
        SidebarEcomerceComponent,
     
        
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        FormsModule,
        
    ]
})
  export class SharedEcomerceModule { }
  